<template>
  <div  class="guest">
    
    <div style="height: 1vh"></div>
    <!-- 列表 -->
    <div class="orderList"  v-if="guestOrderList.length > 0">
      <van-list
        v-model="listLoading"
        :finished="finished"
        finished-text="暂无更多数据"
        :offset="150"
        
        @load="scroll"
      >
        <div class="guestList_item" v-for="item in guestOrderList" style="min-height: 80px;"  :key="item.guestOrderId">
          <div class="info_box" :style="!item.orderId && 'border: 0'">
           
            <div class="info" @click.stop="$router.push({path: 'orderdetail', query: {id: item.guestOrderId, guestInviteId: 'id' in $route.query ? $route.query.id : null}})">
              
              <div class="info_item">
                <p>预约单号：{{item.guestOrderNo}}</p>
              </div>
              <div class="info_item">
                <p>校区名称：{{item.zoneName}}</p>
              </div>
              <div class="info_item">
                <p>登记时间：{{item.applyTime}}</p>
              </div>
              <div class="info_item">
                <p>预约时间：{{item.beginTime | timeFilter}}~{{ item.endTime | timeFilter }}</p>
              </div>
              <div  class="info_item">
                  <p >
                    预约结果：
                    <span style="color: green; font-size: 16px" v-if="item.status == 1">预约成功</span>
                    <span style="font-size: 16px; color: #666" v-if="item.status == 0">待审批</span>
                    <span style="color: red; font-size: 16px" v-if="item.status == -1">预约失败</span>
                  </p>
             </div>
              <!-- <div class="info_item">
                <div style="margin-left: 8px">
                  <p>预约编号：{{item.guestOrderNo}}</p>
                </div>
             </div><div class="info_item">
                <div style="margin-left: 8px">
                  <p>预约时间：{{item.applyTime}}</p>
                </div>
             </div>
             
             
             <div  class="info_item">
                <div style="margin-left: 8px">
                  <p>有效期：{{item.beginTime | timeFilter}}~{{ item.endTime | timeFilter }}</p>
                  
                </div>
             </div>
             <div  class="info_item">
                <div style="margin-left: 8px">
                  <p >
                    预约结果：
                    <span style="color: green; font-size: 16px" v-if="item.status == 1">预约成功</span>
                    <span style="font-size: 16px; color: #666" v-if="item.status == 0">待审批</span>
                    <span style="color: red; font-size: 16px" v-if="item.status == -1">预约失败</span>
                  </p>
                </div>
             </div> -->
           
            </div>
           

          </div>
        </div>
      </van-list>
      
        
    </div>
    <van-empty v-else image="search" description="暂无数据" />
    
  </div>
</template>

<script>
const Dayjs = require("dayjs");
import { getGuestOrder } from '@/api/user'
import { getTokenName } from '@/utils/auth'
export default {
  data () {
    let isM = this.$isMobile
    return {
      guestOrderList: [],
      page: 1,
      total: 0,
      showShareStatus: false,
      baseUrl: process.env.VUE_APP_API_BASE_URL == '/' ? '' : process.env.VUE_APP_API_BASE_URL,
      token: '',
      listLoading: false,
      finished: false,
    }
  },
  created () {
    this.getMyToDo()
    this.token = localStorage.getItem(getTokenName())
  },  
  filters: {
   
    // 时间格式化
    timeFilter (val) {
      if (val) {
        return Dayjs(val).format('YYYY/MM/DD')
      }
    },
    // 身份证脱敏
    idcardFilter (val) {
      if (val && val.length > 5) {
        let str1 = val.substring(0, 2)
        let str2 = val.substring(val.length - 3, val.length)
        for (let index = 0; index < val.length - 5; index++) {
          str1 += '*'
        }
        return str1  + str2
      } else {
        return val
      }
    }, 
  },
  methods: {
    // 获取访客用户
    getMyToDo () {
      getGuestOrder({page: this.page, limit: 10, baseOrderType: 99}).then(res => {
        if(res.code === 0) {
          let guestList = res.page.list.map(item => {
            let items = JSON.parse(JSON.stringify(item))
            if (items.guestList && items.guestList.length) {
              items.guestList.forEach(val => {
                if (val.master == 1) {
                  items = {...val, ...items }
                }
              })
            }
            return items
          })
          this.guestOrderList.push(...guestList)
          if (res.page.list.length) {
            this.finished = false
          } else {
            this.finished = true
          }
          this.listLoading = false
          
          this.total = res.page.totalCount
        }else{
          this.$toast.fail(res.msg)
        }
      }).catch(err => {
        console.error(err, 'err');
        this.$toast.fail('请求失败')
      })
    },
    // 滚动到底部
    scroll () {
      
      if (this.guestOrderList.length < this.total) {
        this.listLoading = true
        this.page += 1
        this.getMyToDo()
      } else {
        this.finished = true
      }
    },
  }
}
</script>
<style scoped lang="less">
.guest {
  background-color: rgb(248, 247, 247);
  height: 100vh;
  overflow: hidden;
  box-sizing: border-box;
  
  .orderList {
    height: 99vh;
    overflow-y: auto;
    
    .empty {
      height: 30px;
      text-align: center;
      color: #999;
      line-height: 40px;
      font-size: 15px;
    }
    .guestList_item {
      background-color: #fff;
      border-radius: 8px;
      margin: 15px;
      padding-bottom: 8px;
      // padding: 5px 10px;
      box-shadow: 0px 0px 14px 3px rgba(0, 0, 0, .115);
      .info_box {
        position: relative;
        border-right: 1px dashed #cfcfcf;
      }
      .info {
        color: #333;
       
        .info_item {
          display: flex;
          align-items: center;
          padding: 5px 10px;
          &:first-child {
            border-bottom: 1px solid #e7e7e7;
            padding: 8px 10px;
            p {
              color: #333 !important; 
              font-weight: bold;
            }
          }
          img {
            width: 30px;
            object-fit: contain;
            vertical-align: middle;
          }
          p {
            &:first-child {
              color: #555;
              font-size: 16px;
            }
            
          }
        }
      }
      .share {
        display: flex;
        flex-direction: column;
        align-items: center;
        color: #666;
        width: 40px;
      }
      .statusImg {
        position: absolute;
        width: 20%;
        max-width: 100px;
        right: 5px;
        bottom: 5px;
        z-index: 10;
        opacity: .8;
      }
    }
    
  }
}
</style>
